import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-arrow-left-16",
  "use": "icon-common-arrow-left-16-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" fill=\"none\" id=\"icon-common-arrow-left-16\">\n  <path d=\"M10.249 4.04657L5.74902 8.54657L10.249 13.0466\" stroke=\"#1D1D1D\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol